const style = `
@font-face {
  font-family:Gilroy;
  src: url('https://cdn140.picsart.com/73791035023790621728.ttf') format('truetype');
}
#qt-widget-root {
  background: #FFFFFF;
  box-shadow: 0px 3px 12px rgba(17, 18, 54, 0.16);
  border-radius: 12px;
  padding: 16px;
}

#qt-widget-container {
  border-style: dashed;
  border-width: 2px;
  border-color: #cccccc;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  gap: 16px;
  align-items: center;
}

#qt-image-logo {
  width: 145px;
  height: 20px;
}

#qt-button {
  text-decoration: none;
  background-color: #C209C1;
  padding: 6px 12px 6px 12px;
  border-radius: 6px;
  border-width: 0px;
  display: flex;
  gap: 8px;
  align-items: center;
}

#qt-button-image {
  width: 12x;
  height: 12px;
}

#qt-button-text {
  font-weight: 600;
  font-family: Gilroy;
  white-space: nowrap;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 19px;
  font-style:normal;
}

@media only screen and (max-width: 480px) {
  #qt-widget-root {
    padding: 12px
  }

  #qt-widget-container {
    flex-direction: column;
    gap: 13px;
    padding: 10px 14px 10px 14px;
  }

  #qt-button {
    gap: 6px;
  }
}
`;

export function CodeForWidgetButton({ toolName, toolUrl }: { toolName: string; toolUrl: string }) {
  return (
    <>
      <style>{style}</style>
      <div id="qt-widget-root">
        <div id="qt-widget-container">
          <img
            id="qt-image-logo"
            width="12px"
            height="12px"
            src="https://cdn140.picsart.com/08412985827068217187.jpg"
          />
          <a id="qt-button" href={toolUrl} target="_blank" rel="noreferrer">
            <span id="qt-button-text"> Open {toolName}</span>
            <img id="qt-button-image" src="https://cdn140.picsart.com/90839707608828510931.svg" />
          </a>
        </div>
      </div>
    </>
  );
}
